import React from "react";
import {Switch} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {Observer, SubNavBar_Auto} from "web-vcore";
import {MeID} from "../Server/DB/users.js";
import {HasModPermissions} from "../Server/DB/users/$user.js";
import {store} from "../Store/index.js";
import {MapsUI} from "./Maps/MapsUI.js";
import {observer_mgl} from "mobx-graphlink";

export const columnWidths = [.64, .06, .12, .18];

export const MapsPage = observer_mgl(()=>{
	//const currentSubpage = store.main.maps.subpage;
	const page = "maps";
	return (
		<>
			<SubNavBar_Auto page={page}/>
			<Switch>
				<MapsUI/>
			</Switch>
		</>
	);
});